import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const decodeSingle = async (kenmerk, lang = 'nl') => {
  const response = await axios.post(`${API_URL}/api/decode?lang=${lang}`, { kenmerk });
  return response.data;
};

export const decodeBulk = async (kenmerken, lang = 'nl') => {
  const response = await axios.post(`${API_URL}/api/decode/bulk?lang=${lang}`, { kenmerken });
  return response.data;
};

export const decodeText = async (text, lang = 'nl') => {
  const response = await axios.post(`${API_URL}/api/decode/text?lang=${lang}`, { text });
  return response.data;
};

export const scanText = async (text, lang = 'nl') => {
  const response = await axios.post(`${API_URL}/api/scan?lang=${lang}`, { text });
  return response.data;
};

export const decodeCsv = async (file, lang = 'nl') => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(`${API_URL}/api/decode/csv?lang=${lang}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const getTaxTypes = async (lang = 'nl') => {
  const response = await axios.get(`${API_URL}/api/tax-types?lang=${lang}`);
  return response.data;
};

export const getUserStats = async () => {
  const response = await axios.get(`${API_URL}/api/stats`);
  return response.data;
};

export const formatKenmerk = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 16);
  return digits.replace(/(\d{4})(?=\d)/g, '$1 ');
};

export const cleanKenmerk = (value) => {
  return value.replace(/\D/g, '');
};
